import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { finalize, Observable, tap } from 'rxjs';
import { TraceIdService } from './trace-id.service';
import { RequestService } from './request.service';

@Injectable({
    providedIn: 'root',
})
export class ResponseInterceptorService {

    constructor(
        private readonly traceIdService: TraceIdService,
        private readonly requestService: RequestService,
    ) {
    }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        this.requestService.lock();

        return next.handle(req).pipe(
            tap(event => {
                if (event instanceof HttpResponse) {
                    this.handleHttpResponse(event);
                }
            }),
            finalize(() => this.requestService.unlock()),
        );
    }

    private handleHttpResponse(event: HttpResponse<unknown>) {
        const traceId = event.headers.get('x-Traceid');

        if (traceId) {
            this.traceIdService.add(traceId);
        }
    }

}
